import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { trackAddToCart } from '../../utils/pixel';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  className?: string;
  withArrow?: boolean;
  scrollTo?: string;
}
export function Button({
  children,
  variant = 'primary',
  className = '',
  withArrow = false,
  scrollTo,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 rounded-full font-medium transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed text-lg';
  const variants = {
    primary: 'bg-rose text-white hover:bg-rose-hover focus:ring-rose shadow-lg shadow-rose/20',
    secondary: 'bg-sage text-white hover:bg-sage/90 focus:ring-sage shadow-lg shadow-sage/20',
    outline: 'border-2 border-sage text-sage hover:bg-sage/10 focus:ring-sage'
  };
  const handleClick = () => {
    if (scrollTo) {
      const el = document.getElementById(scrollTo);
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
      return;
    }
    trackAddToCart();
    window.open('https://argrutinas.com/cart/42971193278673:1', '_blank');
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${className}`} {...props} onClick={handleClick} style={{
    color: '#000000'
  }} data-id="element-166">
      {children}
      {withArrow && <ArrowRight className="ml-2 h-5 w-5" data-id="element-167" />}
    </motion.button>;
}